import { QueryClient } from '@tanstack/react-query';
import { FetchError } from '@cko/dashboard-shared';

const reactQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if ((error as FetchError).code === 408 || (error as FetchError).code >= 500) {
          return failureCount > 3;
        }
        return false;
      },
    },
  },
});

export default reactQueryClient;
